var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 13.5H20.25C19.3219 13.5 18.5625 14.2594 18.5625 15.1875V21.9375C18.5625 22.8656 19.3219 23.625 20.25 23.625H23.625C24.5531 23.625 25.3125 22.8656 25.3125 21.9375V15.1875C25.3125 14.2594 24.5531 13.5 23.625 13.5ZM22.7812 16.0312C22.7812 16.4953 22.4016 16.875 21.9375 16.875C21.4734 16.875 21.0938 16.4953 21.0938 16.0312V15.1875H22.7812V16.0312ZM21.9375 11.8125V5.90625C21.9375 4.51406 20.7984 3.375 19.4062 3.375H4.21875C2.82656 3.375 1.6875 4.51406 1.6875 5.90625V15.1875H16.875C16.875 13.3228 18.3853 11.8125 20.25 11.8125H21.9375ZM1.6875 17.7188C1.6875 19.1109 2.82656 20.25 4.21875 20.25H8.75813L7.91438 21.9375H7.59375C7.12969 21.9375 6.75 22.3172 6.75 22.7812C6.75 23.2453 7.12969 23.625 7.59375 23.625H16.0312C16.4953 23.625 16.875 23.2453 16.875 22.7812C16.875 22.3172 16.4953 21.9375 16.0312 21.9375H15.7191L14.9006 20.25H16.875V16.875H1.6875V17.7188Z",
    fill: "#02020A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3);
export default __webpack_public_path__ + "static/media/phase-3.1339db2751dbdfac6cfbed41e741ae58.svg";
export { ForwardRef as ReactComponent };